/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
/* eslint-disable max-len, no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Stack,
  Card,
  Modal,
  InputAdornment,
  Typography,
  FormGroup,
  FormControlLabel,
  Menu,
  MenuItem,
  Chip
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual, isEmpty, isNil, map, find } from 'lodash';

import FileSaver from 'file-saver';
import MapIcon from '@mui/icons-material/Map';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import uuid from 'uuid/v1';
import ListIcon from '@mui/icons-material/List';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  renderButton,
  renderIconButton,
  renderRadioButton,
  renderSelect,
  renderSwitch,
  renderTextField,
  renderCheckBox
} from '../MaterialMUIComponent';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import {
  ELEMENT_TYPES,
  LIBRARY_ICON_TYPES,
  LIST_MULTI_BASIC_EDIT
} from '../../../api/AnnotationTemplates/AnnotationTemplates';

import ColBreak from '../../atoms/ColBreak';
import ResponsivePlayer from '../ResponsivePlayer';

import Styles from './styles';
import OpenModalFromUrl from '../OpenModalFromUrl';
import UploadFileComponent from '../UploadFileComponent/UploadFileComponent.js';
import ShowListIconsFontawesome from '../ShowListIconsFontawesome/index.js';

import TemplateButtonItem from './TemplateButtonItem/index.js';
import TemplateMapsItem from './TemplateImapsItem/TemplateMapsItem.js';
import TemplatePointCloudItem from './TemplatePointCloudItem/TemplatePointCloudItem.js';
import TemplateCatastroItem from './TemplateCatastroItem/index.js';
import TemplateMultiButtonItem from './TemplateMultiButtonItem/index.js';

import TemplateMultipleItem from './TemplateMultipleItem';

const EDITION_MODE = 'edition';
const PREVIEW_MODE = 'preview';
const FIELDS_SAVE_TEMPLATES = [
  { value: 'none', name: 'None' },
  { value: 'userId', name: 'User ID' },
  { value: 'userLocalId', name: 'User local ID' },
  { value: 'userLocalName', name: 'User local Name' },
  { value: 'address', name: 'Address' },
  { value: 'road', name: 'Road' },
  { value: 'city', name: 'City' },
  { value: 'postcode', name: 'Post Code' },
  { value: 'country', name: 'Country' },
  { value: 'latitud', name: 'Latitude' },
  { value: 'longitud', name: 'Longitude' },
  { value: 'geom', name: 'Geometry Annotation' },
  { value: 'mapId', name: 'Map ID' },
  { value: 'fecha', name: 'Date' },
  { value: 'hora', name: 'Time' },
  { value: 'videoTime', name: 'Time Annotation' },
  { value: 'tiempoGPS', name: 'Time GPS' },
  { value: 'tiempoGPSView', name: 'View Time GPS' },
  { value: 'labelName', name: 'Label Name' },
  { value: 'value', name: 'Value' },
  { value: 'hiperLink', name: 'Link' }
];

// RENDERS MANY ELEMENTS
const renderManyIconButtons = array =>
  map(
    array,
    item =>
      item.isShow &&
      renderIconButton({
        key: `iconButton-${item.icon}-${item.title}`,
        onClick: item.function,
        icon: item.icon,
        titleTooltip: item.title,
        disabled: false,
        style: {
          maxWidth: '38px',
          maxHeight: '38px',
          padding: 0,
          color: item.color || '#2A3F90',
          ...item.style
        }
      })
  );

const renderManyTextField = (array, elementItem, updateAnnotationFields) =>
  map(array, item => (
    <Box
      key={`box-textfield-${templateOps.getElementOrder(elementItem)}-${item.keySave}`}
      sx={{
        display: 'flex',
        mb: 2,
        width: item.widthBox || '100%'
      }}
    >
      {renderTextField({
        key: `textfield-${templateOps.getElementOrder(elementItem)}-${item.keySave}`,
        type: item.type,
        label: item.label,
        style: { ...item.style },
        moreProps: {
          fullWidth: true,
          name: `${templateOps.getElementKey(elementItem)}-${item.keySave}`,
          value: item.value,
          onChange: event => {
            let newValue = event.target.value;
            if (isEqual(item.keySave, 'optionList'))
              newValue = templateOps.transformOptionsStringToArray(event.target.value);
            if (isEqual(item.type, 'number')) newValue = Number(event.target.value);
            updateAnnotationFields(elementItem, item.keySave, newValue);
          },
          sx: {
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 }
          },
          ...item.moreProps
        }
      })}
    </Box>
  ));

const renderMenu = (anchorElMenu, setAnchorElMenu, optionsMenu, handleFieldMenu, element) => (
  <Menu
    anchorEl={anchorElMenu.anchorEl}
    open={Boolean(anchorElMenu.anchorEl)}
    key={`menu-${anchorElMenu.indexField}-column-${anchorElMenu.indexColumn}-${anchorElMenu.orderField}`}
    onClose={() =>
      setAnchorElMenu({
        ...anchorElMenu,
        anchorEl: null
      })
    }
    anchorPosition={{
      left: anchorElMenu.left,
      top: anchorElMenu.top
    }}
  >
    {map(optionsMenu, (fieldMenu, index) => (
      <MenuItem
        value={fieldMenu}
        key={`${fieldMenu}-${anchorElMenu.indexField}-column-${anchorElMenu.indexColumn}-${anchorElMenu.orderField}`}
        onClick={() => {
          setAnchorElMenu({
            ...anchorElMenu,
            anchorEl: null
          });
          handleFieldMenu(
            anchorElMenu.isFieldsDefault ? FIELDS_SAVE_TEMPLATES[index].value : fieldMenu,
            templateOps.getElementOrder(element),
            !anchorElMenu.isFieldsDefault
          );
        }}
      >
        {fieldMenu}
      </MenuItem>
    ))}
  </Menu>
);
const renderManyChips = array =>
  map(
    array,
    item =>
      item.isShow && (
        <Chip
          key={item.key}
          label={item.label}
          size="small"
          style={{ marginLeft: '1%', marginTop: '0.5%' }}
          icon={item.icon}
          onDelete={item.function}
          onClick={item.function}
          deleteIcon={<ArrowDropDownIcon />}
        />
      )
  );

// COMMON ELEMENTS
const commonOpenFullScreen = (openModalProp, setOpenModalProp, moreProps) => {
  const props = {
    isFullScreen: true,
    openModal: openModalProp,
    setOpenModal: setOpenModalProp,
    ...moreProps
  };
  return <OpenModalFromUrl {...props} />;
};
const commonDownloadFromUrl = elementItem => {
  const url = templateOps.getElementValue(elementItem);
  const fileName = url.substring(url.lastIndexOf('/') + 1);
  FileSaver.saveAs(url, fileName);
};

const commonIconsPosition = ({
  updateAnnotationFields,
  elementItem,
  keyValue,
  isLabelName = true
}) => {
  const positionValue = isLabelName
    ? templateOps.getElemenPositionLabelName(elementItem)
    : templateOps.getElemenPosition(elementItem);
  const iconsPosition = [
    {
      function: () => updateAnnotationFields(elementItem, keyValue, 'flex-start'),
      icon: <FontAwesomeIcon icon="align-left" />,
      title: 'Align left',
      disabled: false,
      color: positionValue === 'flex-start' ? 'green' : '#2A3F90',
      isShow: true,
      style: { marginLeft: '2%' }
    },
    {
      function: () => updateAnnotationFields(elementItem, keyValue, 'center'),
      icon: <FontAwesomeIcon icon="align-justify" />,
      title: 'Center',
      disabled: false,
      color: positionValue === 'center' ? 'green' : '#2A3F90',
      isShow: true,
      style: { marginLeft: '2%' }
    },
    {
      function: () => updateAnnotationFields(elementItem, keyValue, 'flex-end'),
      icon: <FontAwesomeIcon icon="align-right" />,
      title: 'Align right',
      disabled: false,
      color: positionValue === 'flex-end' ? 'green' : '#2A3F90',
      isShow: true,
      style: { marginLeft: '2%' }
    }
  ];

  return renderManyIconButtons(iconsPosition);
};

const commonPreviewLabelName = ({
  element,
  mode,
  setOpenAdvancedModal,
  isEmptyValue,
  envSettings,
  isSettingsMode
}) => {
  const settings = templateOps.getSettingsElements(element);
  const configSettings = find(settings, config => isEqual(config.environment, envSettings));
  const isOnlyView = isEmpty(configSettings) ? false : configSettings.onlyView;

  const isActionEnabled = !isOnlyView && isEqual(mode, EDITION_MODE);
  const isShowLabelName = templateOps.getElementisShowLabelName(element);
  let isShowLabel = true;
  let text = templateOps.getElementLabelName(element);
  if (isEqual(mode, PREVIEW_MODE) && isEmptyValue) isShowLabel = false;
  if (isEqual(mode, PREVIEW_MODE) && !isShowLabelName) isShowLabel = false;
  if (isEqual(mode, EDITION_MODE) && isEmpty(text)) text = templateOps.getElementType(element);
  return (
    <>
      {isShowLabel && (
        <Box
          style={{
            fontWeight: 'bold',
            maxWidth: '100%',
            marginTop: '0.5%'
          }}
        >
          <div
            key="labelname"
            role="button"
            label="labelName"
            tabIndex={0}
            style={{
              width: '100%',
              cursor: isActionEnabled || isSettingsMode ? 'pointer' : 'auto'
            }}
            onClick={
              isActionEnabled || isSettingsMode ? () => setOpenAdvancedModal(true) : () => {}
            }
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: text
            }}
          />
        </Box>
      )}
    </>
  );
};

const commonEditionLabelName = ({ elementItem, updateAnnotationFields }) => {
  const isShowLabelName = templateOps.getElementisShowLabelName(elementItem);
  const arrayTextField = [
    {
      widthBox: '90%',
      type: 'text',
      keySave: 'labelName',
      label: '',
      value: templateOps.getElementLabelName(elementItem),
      style: { width: '100%' },
      moreProps: {
        InputProps: {
          endAdornment: (
            <InputAdornment position="end">
              {renderManyIconButtons([
                {
                  function: () =>
                    updateAnnotationFields(elementItem, 'isShowLabelName', !isShowLabelName),
                  icon: <FontAwesomeIcon icon="eye" />,
                  title: 'Show label',
                  color: isShowLabelName ? 'green' : '#2A3F90',
                  isShow: true
                }
              ])}
            </InputAdornment>
          )
        }
      }
    }
  ];

  return (
    <Stack direction="row" display="flex" style={{ maxWidth: '95vh', width: '90vh' }}>
      {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
      {commonIconsPosition({ updateAnnotationFields, elementItem, keyValue: 'positionLabelName' })}
    </Stack>
  );
};

const commonHeaderButtons = ({
  element,
  updateAnnotationFields = () => {},
  envSettings,
  isOnlyView,
  setAnchorElMenu,
  fieldsTableConenction,
  anchorElMenu,
  handleFieldMenu,
  fieldsConnectorElement
}) => {
  const handleMode = () => {
    const settings = templateOps.getSettingsElements(element);
    const configSettings = find(settings, config => isEqual(config.environment, envSettings));
    const indexConfig = settings.indexOf(settings, config =>
      isEqual(config.environment, envSettings)
    );
    if (isEmpty(configSettings) && isEqual(indexConfig, -1))
      settings.push({ environment: envSettings, onlyView: !isOnlyView });
    else {
      settings.splice(indexConfig, 1, { environment: envSettings, onlyView: !isOnlyView });
    }
    updateAnnotationFields(element, 'settings', settings);
  };

  const iconsSettings = [
    {
      function: () => handleMode(),
      icon: <ModeEditIcon />,
      title: !isOnlyView ? 'Only view' : 'Enable edition',
      color: !isOnlyView ? 'green' : '#2A3F90',
      isShow: true,
      style: { marginLeft: '1%' }
    }
  ];
  return (
    <>
      {renderManyIconButtons(iconsSettings)}
      {renderManyChips([
        {
          isShow: true,
          function: event =>
            setAnchorElMenu({
              anchorEl: event.currentTarget,
              left: event.clientX,
              top: event.clientY,
              isFieldsDefault: true
            }),
          key: 'chip-valueToSave-field',
          label: !isEmpty(fieldsConnectorElement.value) ? fieldsConnectorElement.value : 'none',
          icon: <ListIcon />
        },
        {
          isShow: !isEmpty(fieldsTableConenction),
          function: event =>
            setAnchorElMenu({
              anchorEl: event.currentTarget,
              left: event.clientX,
              top: event.clientY,
              isFieldsDefault: false
            }),
          key: 'chip-valueToSave-table',
          label: !isEmpty(fieldsConnectorElement.nameField)
            ? fieldsConnectorElement.nameField
            : 'none',
          icon: <FontAwesomeIcon icon="database" />
        }
      ])}
      {renderMenu(
        anchorElMenu,
        setAnchorElMenu,
        anchorElMenu.isFieldsDefault
          ? map(FIELDS_SAVE_TEMPLATES, item => item.name)
          : fieldsTableConenction,
        handleFieldMenu,
        element
      )}
    </>
  );
};

const commonHeaderTemplates = ({
  element,
  mode,
  isEmptyValue,
  setOpenAdvancedModal,
  envSettings,
  isSettingsMode,
  viewBasicEditMultis,
  setMenuBasicMode,
  anchorElMenu,
  updateAnnotationFields,
  isOnlyView,
  setAnchorElMenu,
  fieldsTableConenction,
  handleFieldMenu,
  fieldsConnectorElement
}) => {
  const renderIcon = el => {
    const typeEl = templateOps.getElementType(el);
    if (isEqual(typeEl, ELEMENT_TYPES.IMAPS) || isEqual(typeEl, ELEMENT_TYPES.MULTIPLEIMAPS))
      return <MapIcon />;
    if (
      isEqual(typeEl, ELEMENT_TYPES.POINTCLOUD) ||
      isEqual(typeEl, ELEMENT_TYPES.MULTIPLEPOINTCLOUD)
    )
      return <CloudOutlinedIcon />;
    if (isEqual(typeEl, ELEMENT_TYPES.MULTIPLEBUTTON)) return <AddCircleOutlineOutlinedIcon />;
    return '';
  };
  const isMultiBasicEdit =
    LIST_MULTI_BASIC_EDIT.includes(templateOps.getElementType(element)) && viewBasicEditMultis;
  return (
    <>
      <Stack
        direction="row"
        display="flex"
        justifyContent={templateOps.getElemenPositionLabelName(element)}
        marginBottom="1%"
      >
        {commonPreviewLabelName({
          element,
          mode,
          setOpenAdvancedModal,
          isEmptyValue,
          envSettings,
          isSettingsMode
        })}
        {!isEqual(mode, PREVIEW_MODE) &&
          isMultiBasicEdit &&
          renderManyIconButtons([
            {
              function: event =>
                setMenuBasicMode({
                  anchor: event.currentTarget,
                  left: event.clientX,
                  top: event.clientY
                }),
              icon: renderIcon(element),
              title: 'Select map',
              style: { padding: '0px', marginLeft: '1%' },
              isShow: true
            }
          ])}
        {isSettingsMode &&
          commonHeaderButtons({
            element,
            updateAnnotationFields,
            envSettings,
            isOnlyView,
            setAnchorElMenu,
            fieldsTableConenction,
            anchorElMenu,
            handleFieldMenu,
            fieldsConnectorElement
          })}
      </Stack>
    </>
  );
};

const commonPreviewValue = ({ elementItem }) => {
  const value = templateOps.getElementValue(elementItem);
  let valueString = value;
  if (templateOps.getElementDataType(elementItem) === 'number') valueString = value.toString();
  if (!isEmpty(valueString))
    return (
      <div
        style={{
          // display: 'flex',
          justifyContent: templateOps.getElemenPosition(elementItem)
        }}
        dangerouslySetInnerHTML={{
          __html: valueString
        }}
      />
    );
  return '';
};

const commonEditionValue = ({ elementItem, updateAnnotationFields }) => {
  const arrayTextField = [
    {
      widthBox: '90%',
      type: templateOps.getElementDataType(elementItem),
      keySave: 'value',
      label: '',
      value: templateOps.getElementValue(elementItem),
      style: { width: '100%' },
      moreProps: isEqual(templateOps.getElementType(elementItem), ELEMENT_TYPES.TEXTAREA)
        ? { multiline: true, minRows: 5, maxRows: 15 }
        : {}
    }
  ];
  return renderManyTextField(arrayTextField, elementItem, updateAnnotationFields);
};

const commonPreviewCaptionElements = ({ elementItem, elementRowOne, elementRowTwo }) => {
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  const typeElement = templateOps.getElementType(elementItem);
  const isEnviromentIpsilum = templateOps.getElemenFullScreenEnv(elementItem);
  const func = isEnviromentIpsilum
    ? () => setOpenFullScreen(true)
    : () => window.open(templateOps.getElementValue(elementItem));
  const defaultElementRowTwo = [
    {
      title: 'Fullscreen',
      function: () => func(),
      icon: <FontAwesomeIcon icon="expand" />,
      isShow: templateOps.getEnabledFullScreen(elementItem),
      style: { marginRight: '5%' }
    }
  ];
  const objectsRowTwo = !isEqual(typeElement, ELEMENT_TYPES.STREETVIEW)
    ? defaultElementRowTwo.concat(elementRowTwo)
    : elementRowTwo;
  const elementsRowTwo = renderManyIconButtons(objectsRowTwo);
  const renderTooltip = () => {
    return (
      <Stack width="100%" direction="row" display="flex" justifyContent="space-between">
        {templateOps.getElementIsShowCaption(elementItem) && (
          <Typography marginRight="5%">{templateOps.getElementCaption(elementItem)}</Typography>
        )}
        {elementsRowTwo}
      </Stack>
    );
  };
  return (
    <>
      <Styles.LightTooltip
        key={uuid()}
        title={renderTooltip()}
        display="flex"
        justifycontent={templateOps.getElemenPosition(elementItem)}
      >
        {!isEqual(typeElement, ELEMENT_TYPES.IMAGE) ? (
          <Card
            height={`${templateOps.getElementHeight(elementItem)}%`}
            width={`${templateOps.getElementHeight(elementItem)}%`}
          >
            {elementRowOne}
          </Card>
        ) : (
          <Box key={uuid()} width="100%" display="flex" justifyContent="flex-start">
            {elementRowOne}
          </Box>
        )}
      </Styles.LightTooltip>
      {commonOpenFullScreen(openFullScreen, setOpenFullScreen, {
        url: !isEqual(typeElement, ELEMENT_TYPES.VIDEO)
          ? templateOps.getElementValue(elementItem)
          : '',
        title: templateOps.getElementCaption(elementItem),
        isImage: isEqual(typeElement, ELEMENT_TYPES.IMAGE),
        isComponent: isEqual(typeElement, ELEMENT_TYPES.VIDEO),
        component: () => elementRowOne[0]
      })}
    </>
  );
};

const commonEditCaptionElements = ({ elementItem, updateAnnotationFields, isAdvancedMode }) => {
  const isEnviromentIpsilum = templateOps.getElemenFullScreenEnv(elementItem);
  return (
    <>
      {isAdvancedMode && (
        <Stack direction="row" width="100%" display="flex">
          {renderSwitch({
            checked: isEnviromentIpsilum,
            onChange: () => {
              updateAnnotationFields(elementItem, 'fullScreenIpsilumEnv', !isEnviromentIpsilum);
            },
            labelCheck: 'Inside Ipsilum',
            labelUncheck: 'New Window'
          })}
          {renderSwitch({
            checked: templateOps.getElementisDownload(elementItem),
            onChange: () => {
              updateAnnotationFields(
                elementItem,
                'isDownload',
                !templateOps.getElementisDownload(elementItem)
              );
            },
            labelCheck: 'Enabled download',
            labelUncheck: 'Disabled download'
          })}
          {renderSwitch({
            checked: templateOps.getEnabledFullScreen(elementItem),
            onChange: () => {
              updateAnnotationFields(
                elementItem,
                'enabledFullScreen',
                !templateOps.getEnabledFullScreen(elementItem)
              );
            },
            labelCheck: 'Enabled full screen',
            labelUncheck: 'Disabled full screen'
          })}
          {commonIconsPosition({
            updateAnnotationFields,
            elementItem,
            keyValue: 'positionElement',
            isLabelName: false
          })}
        </Stack>
      )}
      <UploadFileComponent
        linkValueProp={templateOps.getElementValue(elementItem)}
        handleValueLink={link => updateAnnotationFields(elementItem, 'value', link)}
      />
    </>
  );
};

const commonListIcons = ({
  elementItem,
  updateAnnotationFields,
  openModalIcon,
  setOpenModalIcon
}) => {
  const iconElement = templateOps.getElementIcon(elementItem);
  const renderIcon = () => {
    if (iconElement.library === LIBRARY_ICON_TYPES.FONTAWESOME)
      return <FontAwesomeIcon icon={iconElement.icon} />;
    if (iconElement.library === LIBRARY_ICON_TYPES.SVG)
      return (
        <img
          src={iconElement.linkSvg}
          alt={iconElement.icon}
          style={{ marginRight: '5px', width: '20px', height: '20px' }}
        />
      );
    return <FontAwesomeIcon icon={iconElement.icon} />;
  };
  return (
    <>
      {renderManyIconButtons([
        {
          title: 'Icons list',
          function: () => setOpenModalIcon(true),
          icon: renderIcon(),
          isShow: true,
          style: { marginLeft: '2%' }
        }
      ])}
      <ShowListIconsFontawesome
        openModal={openModalIcon}
        setOpenModal={setOpenModalIcon}
        handleIconSelected={(elementIcon, lib) => {
          if (isEqual(lib, LIBRARY_ICON_TYPES.FONTAWESOME))
            updateAnnotationFields(elementItem, 'iconElement', {
              library: lib,
              icon: elementIcon
            });
          if (isEqual(lib, LIBRARY_ICON_TYPES.SVG))
            updateAnnotationFields(elementItem, 'iconElement', {
              library: lib,
              icon: elementIcon.name,
              linkSvg: elementIcon.url,
              categorySvg: elementIcon.category
            });
        }}
        selectedIcon={iconElement.icon}
        startLibrary={iconElement.library}
        svg={isEqual(iconElement.library, LIBRARY_ICON_TYPES.SVG) ? iconElement.linkSvg : ''}
        startCategorySvg={
          isEqual(iconElement.library, LIBRARY_ICON_TYPES.SVG) ? iconElement.categorySvg : ''
        }
      />
    </>
  );
};

// ANNOTATIONS TEMPLATES

const ButtonItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  ...rest
}) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplateButtonItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        isAdvancedMode={isAdvancedMode}
        previewMode={previewMode}
        {...rest}
      />
    </>
  );
};
ButtonItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

ButtonItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired
};

const CatastroItem = ({
  elementItem,
  updateAnnotationFields,
  updatedAnnotation,
  selectedAnnotation,
  isAdvancedMode,
  previewMode,
  ...rest
}) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplateCatastroItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        updatedAnnotation={updatedAnnotation}
        selectedAnnotation={selectedAnnotation}
        isAdvancedMode={isAdvancedMode}
        previewMode={previewMode}
        {...rest}
      />
    </>
  );
};

CatastroItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  updatedAnnotation: {},
  selectedAnnotation: {}
};

CatastroItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired
};

const IconItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  const [openModalIcon, setOpenModalIcon] = React.useState(false);
  const isEnviromentIpsilum = templateOps.getElemenFullScreenEnv(elementItem);
  const iconElement = templateOps.getElementIcon(elementItem);
  const func = isEnviromentIpsilum
    ? () => setOpenFullScreen(true)
    : () => window.open(templateOps.getElementValue(elementItem));
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {isEqual(previewMode, PREVIEW_MODE) && !isEmpty(templateOps.getElementValue(elementItem)) && (
          <>
            <Stack
              direction="row"
              width="100%"
              height="100%"
              display="flex"
              justifyContent={templateOps.getElemenPosition(elementItem)}
            >
              {renderButton({
                key: 'iconItem',
                onClick: func,
                contentButton: (
                  <>
                    {isEqual(iconElement.library, LIBRARY_ICON_TYPES.FONTAWESOME) && (
                      <FontAwesomeIcon icon={iconElement.icon} size="lg" />
                    )}
                    {isEqual(iconElement.library, LIBRARY_ICON_TYPES.SVG) && (
                      <img
                        src={iconElement.linkSvg}
                        alt={iconElement.icon}
                        style={{ marginRight: '5px', width: '20px', height: '20px' }}
                      />
                    )}
                    <span className="ml-1">{templateOps.getElementCaption(elementItem)}</span>
                  </>
                ),
                moreProps: {
                  variant: 'link',
                  target: '_blank',
                  rel: 'noreferrer noopener'
                }
              })}
              {renderManyIconButtons([
                {
                  title: 'download',
                  function: () => commonDownloadFromUrl(elementItem),
                  icon: <FontAwesomeIcon icon="download" />,
                  isShow: templateOps.getElementisDownload(elementItem)
                },
                {
                  title: 'Fullscreen',
                  function: () => setOpenFullScreen(true),
                  icon: <FontAwesomeIcon icon="expand" />,
                  style: { marginLeft: '2%' },
                  isShow: templateOps.getEnabledFullScreen(elementItem)
                }
              ])}
            </Stack>
            {commonOpenFullScreen(openFullScreen, setOpenFullScreen, {
              url: templateOps.getElementValue(elementItem)
            })}
          </>
        )}
      </>
    );

  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'text',
        keySave: 'caption',
        label: 'Caption for the image',
        value: templateOps.getElementCaption(elementItem),
        style: {},
        moreProps: {
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                {renderManyIconButtons([
                  {
                    function: () =>
                      updateAnnotationFields(
                        elementItem,
                        'isShowCaption',
                        !templateOps.getElementIsShowCaption(elementItem)
                      ),
                    icon: <FontAwesomeIcon icon="eye" />,
                    title: 'Show caption text',
                    color: templateOps.getElementIsShowCaption(elementItem) ? 'green' : '#2A3F90',
                    isShow: true
                  }
                ])}
              </InputAdornment>
            )
          }
        }
      }
    ];
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row" width="100%" height="100%">
          <Stack direction="column" width="100%">
            {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
          </Stack>
          <Stack direction="column" marginTop="1%" marginLeft="1%">
            {commonListIcons({
              elementItem,
              updateAnnotationFields,
              openModalIcon,
              setOpenModalIcon
            })}
          </Stack>
        </Stack>
      </>
    );
  }
  return '';
};

IconItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

IconItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const IframeItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const elementRowOne = [
    <Styles.Iframe
      key={`iframeItem-${templateOps.getElementKey(elementItem)}`}
      src={templateOps.getElementValue(elementItem)}
      height={`${templateOps.getElementHeight(elementItem)}px`}
      width="100%"
      title="External Page"
    />
  ];
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {!isEmpty(templateOps.getElementValue(elementItem)) &&
          commonPreviewCaptionElements({
            elementItem,
            elementRowOne,
            elementRowTwo: []
          })}
      </>
    );
  if (isAdvancedMode) {
    const textFieldCaption = [
      {
        type: 'text',
        keySave: 'caption',
        label: 'Caption for the image',
        value: templateOps.getElementCaption(elementItem),
        style: { width: '95%' },
        moreProps: {
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                {renderManyIconButtons([
                  {
                    function: () =>
                      updateAnnotationFields(
                        elementItem,
                        'isShowCaption',
                        !templateOps.getElementIsShowCaption(elementItem)
                      ),
                    icon: <FontAwesomeIcon icon="eye" />,
                    title: 'Show caption text',
                    color: templateOps.getElementIsShowCaption(elementItem) ? 'green' : '#2A3F90',
                    isShow: true
                  }
                ])}
              </InputAdornment>
            )
          }
        }
      }
    ];

    const sizesTextField = [
      {
        type: 'number',
        keySave: 'height',
        label: 'Height for the iframe',
        value: templateOps.getElementHeight(elementItem),
        style: { width: '100%' }
      },
      {
        type: 'number',
        keySave: 'width',
        label: 'Width for the iframe',
        value: templateOps.getElementWidth(elementItem),
        style: { width: '100%' }
      }
    ];

    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {renderManyTextField(textFieldCaption, elementItem, updateAnnotationFields)}
        <Stack direction="row" display="flex" width="95%">
          {renderManyTextField(sizesTextField, elementItem, updateAnnotationFields)}
        </Stack>
      </>
    );
  }
  return '';
};

IframeItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

IframeItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const ImageItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  if (!isAdvancedMode) {
    const elementRowOne = [
      renderButton({
        key: 'imageItem',
        style: { padding: 0, border: 0 },
        disabled: isEmpty(templateOps.getElementHiperLink(elementItem)),
        moreProps: {
          href: templateOps.getElementHiperLink(elementItem)
        },
        contentButton: (
          <img
            src={templateOps.getElementValue(elementItem)}
            alt="imagen"
            width={`${templateOps.getElementHeight(elementItem)}px`}
            height={`${templateOps.getElementHeight(elementItem)}px`}
          />
        )
      })
    ];
    const elementRowTwo = [
      {
        title: 'Download',
        function: () => commonDownloadFromUrl(elementItem),
        icon: <FontAwesomeIcon icon="download" />,
        isShow: templateOps.getElementisDownload(elementItem)
      }
    ];
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {!isEmpty(templateOps.getElementValue(elementItem)) &&
          commonPreviewCaptionElements({
            elementItem,
            elementRowOne,
            elementRowTwo
          })}
      </>
    );
  }

  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'text',
        keySave: 'caption',
        label: 'Caption for the image',
        value: templateOps.getElementCaption(elementItem),
        style: { width: '95%' },
        moreProps: {
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                {renderManyIconButtons([
                  {
                    function: () =>
                      updateAnnotationFields(
                        elementItem,
                        'isShowCaption',
                        !templateOps.getElementIsShowCaption(elementItem)
                      ),
                    icon: <FontAwesomeIcon icon="eye" />,
                    title: 'Show caption text',
                    color: templateOps.getElementIsShowCaption(elementItem) ? 'green' : '#2A3F90',
                    isShow: true
                  }
                ])}
              </InputAdornment>
            )
          }
        }
      },
      {
        type: 'text',
        keySave: 'hiperLink',
        label: 'Hiperlink for the image',
        value: templateOps.getElementHiperLink(elementItem),
        style: { width: '95%' }
      },
      {
        type: 'number',
        keySave: 'height',
        label: 'Height for the image',
        value: templateOps.getElementHeight(elementItem),
        style: { width: '95%' }
      }
    ];

    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
      </>
    );
  }

  return '';
};

ImageItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

ImageItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const InputItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, PREVIEW_MODE) &&
          commonPreviewValue({ elementItem, updateAnnotationFields })}
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditionValue({ elementItem, updateAnnotationFields })}
      </>
    );
  if (isAdvancedMode)
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row" display="flex" style={{ maxWidth: '95vh', width: '90vh' }}>
          {commonEditionValue({ elementItem, updateAnnotationFields })}
          {commonIconsPosition({
            updateAnnotationFields,
            elementItem,
            keyValue: 'positionElement',
            isLabelName: false
          })}
        </Stack>
      </>
    );
  return '';
};

InputItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

InputItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const LinkItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {!isEmpty(templateOps.getElementValue(elementItem)) && (
          <Stack
            direction="row"
            width="100%"
            height="100%"
            display="flex"
            justifyContent={templateOps.getElemenPosition(elementItem)}
          >
            {renderManyIconButtons([
              {
                title: '',
                function: () => window.open(templateOps.getElementValue(elementItem)),
                icon: <FontAwesomeIcon icon="globe-africa" />,
                isShow: isEmpty(templateOps.getElementCaption(elementItem))
              },
              {
                title: 'Fullscreen',
                function: () => setOpenFullScreen(true),
                icon: <FontAwesomeIcon icon="expand" />,
                style: { marginLeft: '2%' },
                isShow: templateOps.getEnabledFullScreen(elementItem)
              },
              {
                title: 'Download',
                function: () => commonDownloadFromUrl(elementItem),
                icon: <FontAwesomeIcon icon="download" />,
                style: { marginLeft: '2%', marginRight: '2%' },
                isShow: templateOps.getElementisDownload(elementItem)
              }
            ])}
            <a href={templateOps.getElementValue(elementItem)} target="_blank" rel="noreferrer">
              {templateOps.getElementCaption(elementItem)}
            </a>
            {commonOpenFullScreen(openFullScreen, setOpenFullScreen, {
              url: templateOps.getElementValue(elementItem)
            })}
          </Stack>
        )}
      </>
    );
  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'text',
        keySave: 'caption',
        label: 'Caption for the link',
        value: templateOps.getElementCaption(elementItem),
        style: { width: '95%' }
      }
    ];
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
      </>
    );
  }
  return '';
};
LinkItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

LinkItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const MapsItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  ...rest
}) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplateMapsItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        isAdvancedMode={isAdvancedMode}
        previewMode={previewMode}
        {...rest}
      />
    </>
  );
};

MapsItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

MapsItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired
};

const MultipleButtonItem = ({ elementItem, updateAnnotationFields, isAdvancedMode, ...rest }) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplateMultiButtonItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        isAdvancedMode={isAdvancedMode}
        {...rest}
      />
    </>
  );
};

MultipleButtonItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

MultipleButtonItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired
};

const MultipleItems = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  ...rest
}) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplateMultipleItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        isAdvancedMode={isAdvancedMode}
        previewMode={previewMode}
        {...rest}
      />
    </>
  );
};

MultipleItems.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

MultipleItems.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired
};

const MultipleSelectorItem = ({
  elementItem,
  updateAnnotationFields,
  previewMode,
  isAdvancedMode
}) => {
  const multiValues = templateOps.getElementMultiValues(elementItem);
  const optionsSelected = map(multiValues, item => item.name);

  const handleOption = option => {
    const itemSelect = find(multiValues, item => isEqual(item.name, option));
    const index = multiValues.indexOf(itemSelect);
    if (isEqual(index, -1))
      updateAnnotationFields(elementItem, 'multiValues', [...multiValues, { name: option }]);
    else {
      multiValues.splice(index, 1);
      updateAnnotationFields(elementItem, 'multiValues', multiValues);
    }
  };

  return (
    <>
      {isEqual(previewMode, PREVIEW_MODE) && (
        <>
          {commonPreviewValue({ elementItem, updateAnnotationFields })}
          {map(multiValues, item => (
            <Box maxHeight="50%" overflow="auto">
              <Typography>{item.name}</Typography>
            </Box>
          ))}
        </>
      )}

      {isEqual(previewMode, EDITION_MODE) && (
        <>
          {isAdvancedMode &&
            commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}

          {renderManyTextField(
            [
              {
                type: 'text',
                keySave: 'optionList',
                label: '',
                value: templateOps.transformOptionsArrayToString(
                  templateOps.getElementOptionList(elementItem)
                )
              }
            ],
            elementItem,
            updateAnnotationFields
          )}
          <Box
            key={`${templateOps.getElementOrder(elementItem)}-edit`}
            maxHeight="50%"
            overflow="auto"
          >
            <FormGroup>
              {map(templateOps.getElementOptionList(elementItem), item => (
                <FormControlLabel
                  key={`formControl-${templateOps.getElementOrder(elementItem)}-edit`}
                  control={renderCheckBox({
                    key: `checkbox-${templateOps.getElementOrder(elementItem)}-${item}`,
                    onChange: () => handleOption(item),
                    value: optionsSelected.includes(item),
                    moreProps: {
                      isrow: false
                    }
                  })}
                  label={item}
                />
              ))}
            </FormGroup>
          </Box>
        </>
      )}
    </>
  );
};

MultipleSelectorItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

MultipleSelectorItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  previewMode: PropTypes.string.isRequired,
  isAdvancedMode: PropTypes.bool.isRequired
};

const PointCloudItem = ({ elementItem, updateAnnotationFields, isAdvancedMode, ...rest }) => {
  return (
    <>
      {isAdvancedMode &&
        commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
      <TemplatePointCloudItem
        elementItem={elementItem}
        updateAnnotationFields={updateAnnotationFields}
        isAdvancedMode={isAdvancedMode}
        {...rest}
      />
    </>
  );
};
PointCloudItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

PointCloudItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired
};

const RadioItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  isSettingsMode,
  viewBasicEditMultis
}) => {
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, PREVIEW_MODE) &&
          commonPreviewValue({ elementItem, updateAnnotationFields })}
        {isEqual(previewMode, EDITION_MODE) &&
          isSettingsMode &&
          renderManyTextField(
            [
              {
                type: 'text',
                keySave: 'optionList',
                label: '',
                value: templateOps.transformOptionsArrayToString(
                  templateOps.getElementOptionList(elementItem)
                )
              }
            ],
            elementItem,
            updateAnnotationFields
          )}
        {isEqual(previewMode, EDITION_MODE) && viewBasicEditMultis && (
          <Box maxHeight="100%" overflow="auto">
            {renderRadioButton({
              isRow: false,
              arrayOptions: templateOps.getElementOptionList(elementItem),
              onChange: option => updateAnnotationFields(elementItem, 'value', option),
              valueChecked: templateOps.getElementValue(elementItem),
              moreProps: {
                name: templateOps.getElementKey(elementItem)
              }
            })}
          </Box>
        )}
      </>
    );
  if (isAdvancedMode)
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Box maxHeight="40vh" overflow="auto">
          {renderRadioButton({
            isRow: false,
            arrayOptions: templateOps.getElementOptionList(elementItem),
            onChange: option => updateAnnotationFields(elementItem, 'value', option),
            valueChecked: templateOps.getElementValue(elementItem),
            moreProps: {
              name: templateOps.getElementKey(elementItem)
            }
          })}
        </Box>
      </>
    );

  return '';
};

RadioItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  isSettingsMode: false
};

RadioItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  isSettingsMode: PropTypes.bool,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const SelectItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  isSettingsMode,
  viewBasicEditMultis
}) => {
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, PREVIEW_MODE) &&
          commonPreviewValue({ elementItem, updateAnnotationFields })}
        {isEqual(previewMode, EDITION_MODE) &&
          isSettingsMode &&
          renderManyTextField(
            [
              {
                type: 'text',
                keySave: 'optionList',
                label: '',
                value: templateOps.transformOptionsArrayToString(
                  templateOps.getElementOptionList(elementItem)
                )
              }
            ],
            elementItem,
            updateAnnotationFields
          )}
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          renderSelect({
            onChange: event => updateAnnotationFields(elementItem, 'value', event.target.value),
            value: templateOps.getElementValue(elementItem),
            arrayOptions: templateOps.getElementOptionList(elementItem),
            moreProps: {
              name: templateOps.getElementKey(elementItem),
              sx: {
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }
            }
          })}
      </>
    );
  if (isAdvancedMode)
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row" display="flex" style={{ maxWidth: '95vh', width: '90vh' }}>
          {renderSelect({
            onChange: event => updateAnnotationFields(elementItem, 'value', event.target.value),
            value: templateOps.getElementValue(elementItem),
            arrayOptions: templateOps.getElementOptionList(elementItem),
            moreProps: {
              name: templateOps.getElementKey(elementItem),
              sx: {
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }
            }
          })}

          {commonIconsPosition({
            updateAnnotationFields,
            elementItem,
            keyValue: 'positionElement',
            isLabelName: false
          })}
        </Stack>
      </>
    );

  return '';
};

SelectItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  isSettingsMode: false
};

SelectItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  isSettingsMode: PropTypes.bool,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const StreetViewItem = ({
  elementItem,
  updateAnnotationFields,
  updatedAnnotation,
  selectedAnnotation,
  annotation,
  isAdvancedMode
}) => {
  let coords = [-3.8240100684791924, 40.47385105369546];
  if (!isEmpty(updatedAnnotation)) {
    coords = updatedAnnotation.geoJSON.geometry.coordinates;
  } else if (!isEmpty(selectedAnnotation)) {
    coords = selectedAnnotation.geoJSON.geometry.coordinates;
  } else if (!isEmpty(annotation)) {
    coords = annotation.geoJSON.geometry.coordinates;
  }

  const elementRowOne = [
    <Styles.Iframe
      key={`streetView-${templateOps.getElementKey(elementItem)}`}
      src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCgXcfztuA0NG4n_pXFYyEmdLZNWIdEHAo&location=${coords[1]},${coords[0]}&heading=210&pitch=10&fov=35`}
      height={`${templateOps.getElementHeight(elementItem)}px`}
      width="100%"
      title="External Page"
    />
  ];
  const buttons = [
    {
      title: 'Open new window',
      function: () =>
        window.open(
          `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coords[1]},${coords[0]}`
        ),
      icon: <FontAwesomeIcon icon="file-export" />,
      isShow: true
    }
  ];
  const elementRowTwo = templateOps.getElemenFullScreenEnv(elementItem) ? buttons : [];

  if (!isAdvancedMode)
    return <>{commonPreviewCaptionElements({ elementItem, elementRowOne, elementRowTwo })}</>;
  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'number',
        keySave: 'height',
        label: 'Height for the iframe',
        value: templateOps.getElementHeight(elementItem),
        style: { width: '100%' }
      },
      {
        type: 'number',
        keySave: 'width',
        label: 'Width for the iframe',
        value: templateOps.getElementWidth(elementItem),
        style: { width: '100%' }
      }
    ];
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row">
          {renderSwitch({
            checked: templateOps.getElemenFullScreenEnv(elementItem),
            onChange: () =>
              updateAnnotationFields(
                elementItem,
                'fullScreenIpsilumEnv',
                !templateOps.getElemenFullScreenEnv(elementItem)
              ),
            labelCheck: 'Enabled open new window',
            labelUncheck: 'Disabled open new window'
          })}
          {commonIconsPosition({
            updateAnnotationFields,
            elementItem,
            keyValue: 'positionElement',
            isLabelName: false
          })}
        </Stack>
        <Stack direction="row" display="flex" width="95%">
          {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
        </Stack>
      </>
    );
  }
  return '';
};

StreetViewItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  updatedAnnotation: {},
  selectedAnnotation: {},
  annotation: {}
};

StreetViewItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  annotation: PropTypes.object,
  isAdvancedMode: PropTypes.bool.isRequired
};

const TextAreaItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, PREVIEW_MODE) &&
          commonPreviewValue({ elementItem, updateAnnotationFields })}
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditionValue({ elementItem, updateAnnotationFields })}
      </>
    );

  if (isAdvancedMode)
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row" display="flex" style={{ maxWidth: '95vh', width: '90vh' }}>
          {commonEditionValue({ elementItem, updateAnnotationFields })}
          {commonIconsPosition({
            updateAnnotationFields,
            elementItem,
            keyValue: 'positionElement',
            isLabelName: false
          })}
        </Stack>
      </>
    );
  return '';
};

TextAreaItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

TextAreaItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const UploadFileItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const elementRowOne = [
    <Styles.Iframe
      key={`uploadItem-${templateOps.getElementKey(elementItem)}`}
      src={templateOps.getElementValue(elementItem)}
      height={`${templateOps.getElementHeight(elementItem)}px`}
      width="100%"
      title="External Page"
    />
  ];
  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {!isEmpty(templateOps.getElementValue(elementItem)) &&
          commonPreviewCaptionElements({
            elementItem,
            elementRowOne,
            elementRowTwo: []
          })}
      </>
    );
  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'number',
        keySave: 'height',
        label: 'Height for the iframe',
        value: templateOps.getElementHeight(elementItem),
        style: { width: '100%' }
      },
      {
        type: 'number',
        keySave: 'width',
        label: 'Width for the iframe',
        value: templateOps.getElementWidth(elementItem),
        style: { width: '100%' }
      }
    ];
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        <Stack direction="row" display="flex" width="95%">
          {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
        </Stack>
      </>
    );
  }
  return '';
};

UploadFileItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

UploadFileItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const VideoItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const playerVars = {
    modestbranding: 1,
    rel: 0,
    showinfo: 0
  };
  const elementRowOne = [
    <ResponsivePlayer
      key={uuid()}
      url={templateOps.getElementValue(elementItem)}
      showControls={false}
      playerVars={playerVars}
      isPreviewMapEditor
    />
  ];

  if (!isAdvancedMode)
    return (
      <>
        {isEqual(previewMode, EDITION_MODE) &&
          viewBasicEditMultis &&
          commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {!isEmpty(templateOps.getElementValue(elementItem)) &&
          commonPreviewCaptionElements({
            elementItem,
            elementRowOne,
            elementRowTwo: []
          })}
      </>
    );

  if (isAdvancedMode) {
    const arrayTextField = [
      {
        type: 'text',
        keySave: 'caption',
        label: 'Caption for the video',
        value: templateOps.getElementCaption(elementItem),
        style: { width: '95%' }
      }
    ];
    return (
      <>
        {commonEditionLabelName({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {commonEditCaptionElements({ elementItem, updateAnnotationFields, isAdvancedMode })}
        {renderManyTextField(arrayTextField, elementItem, updateAnnotationFields)}
      </>
    );
  }
  return '';
};

VideoItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update')
};

VideoItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

const TemplateItem = ({
  annotationTemplate,
  rowNumber,
  columnNumber,
  itemNumber,
  previewMode,
  isSettingsMode,
  envSettings,
  fieldsTableConenction,
  handleFieldMenu,
  fieldsMenusValues,
  ...rest
}) => {
  const { updateAnnotationFields } = rest;
  const [openAdvancedModal, setOpenAdvancedModal] = React.useState(false);
  const [menuBasicMode, setMenuBasicMode] = React.useState({ anchor: null, top: 0, left: 0 });
  const [anchorElMenu, setAnchorElMenu] = React.useState({
    anchorEl: null,
    top: 0,
    left: 0,
    isFieldsDefault: true
  });

  const elementItem = templateOps.getElementItem({
    annotationTemplateObject: annotationTemplate,
    rowNumber,
    columnNumber,
    itemNumber
  });
  if (isNil(elementItem)) return '';

  const isPreviewMode = isEqual(previewMode, PREVIEW_MODE);
  const settings = templateOps.getSettingsElements(elementItem);
  const configSettings = find(settings, config => isEqual(config.environment, envSettings));
  const isOnlyView = isEmpty(configSettings) ? false : configSettings.onlyView;
  const viewBasicEditMultis = !isOnlyView || isSettingsMode;
  let fieldsConnectorElement = find(fieldsMenusValues, item =>
    isEqual(item.elementIndex || -1, templateOps.getElementOrder(elementItem))
  );
  if (isEmpty(fieldsConnectorElement))
    fieldsConnectorElement = { value: 'none', nameField: 'none' };
  let isEmptyValue = false;

  const renderItem = (element, mode) => {
    switch (templateOps.getElementType(element)) {
      case ELEMENT_TYPES.BUTTON:
        if (
          (isEmpty(templateOps.getElementValue(element)) ||
            isEmpty(templateOps.getElementHiperLink(element))) &&
          isPreviewMode
        )
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <ButtonItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.CATASTRO:
        if (isEmpty(templateOps.getElementConnections(element)) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <CatastroItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.ICON:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <IconItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.IFRAME:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <IframeItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.IMAGE:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <ImageItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.INPUT:
        if (isEmpty(templateOps.getElementValue(elementItem).toString()) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <InputItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.LINK:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <LinkItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.IMAPS:
      case ELEMENT_TYPES.MULTIPLEIMAPS:
        if (isEqual(templateOps.getElementType(elementItem), ELEMENT_TYPES.MULTIPLEIMAPS)) {
          if (isEmpty(templateOps.getElementMultipleMaps(elementItem)) && isPreviewMode)
            isEmptyValue = true;
        } else if (isEmpty(templateOps.getElementMap(elementItem)) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <MapsItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              menuBasicMode={menuBasicMode}
              setMenuBasicMode={setMenuBasicMode}
              envSettings={envSettings}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.MULTIPLEBUTTON:
        if (isEmpty(templateOps.getElementMultiValues(elementItem)) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <MultipleButtonItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.MULTIPLEIFRAME:
      case ELEMENT_TYPES.MULTIPLEPICTURES:
      case ELEMENT_TYPES.MULTIPLEVIDEOS:
        if (isEmpty(templateOps.getElementMultiValues(elementItem)) && isPreviewMode)
          isEmptyValue = true;

        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <MultipleItems
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.POINTCLOUD:
      case ELEMENT_TYPES.MULTIPLEPOINTCLOUD:
        if (isEqual(templateOps.getElementType(elementItem), ELEMENT_TYPES.MULTIPLEPOINTCLOUD)) {
          if (isEmpty(templateOps.getElementMultiplePointCloud(elementItem)) && isPreviewMode)
            isEmptyValue = true;
        } else if (isEmpty(templateOps.getElementConnections(elementItem)) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <PointCloudItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.MULTIPLESELECTOR:
        if (isEmpty(templateOps.getElementMultiValues(elementItem)) && isPreviewMode)
          isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <MultipleSelectorItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.RADIO:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <RadioItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isSettingsMode={isSettingsMode}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.SELECT:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <SelectItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isSettingsMode={isSettingsMode}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.STREETVIEW:
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <StreetViewItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.TEXTAREA:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <TextAreaItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.UPLOADFILE:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <UploadFileItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      case ELEMENT_TYPES.VIDEO:
        if (isEmpty(templateOps.getElementValue(elementItem)) && isPreviewMode) isEmptyValue = true;
        return (
          <>
            {!openAdvancedModal &&
              commonHeaderTemplates({
                element,
                mode,
                isEmptyValue,
                setOpenAdvancedModal,
                envSettings,
                isSettingsMode,
                viewBasicEditMultis,
                setMenuBasicMode,
                anchorElMenu,
                updateAnnotationFields,
                isOnlyView,
                setAnchorElMenu,
                fieldsTableConenction,
                handleFieldMenu,
                fieldsConnectorElement
              })}
            <VideoItem
              elementItem={element}
              previewMode={mode}
              isAdvancedMode={openAdvancedModal}
              envSettings={envSettings}
              isOnlyView={isOnlyView}
              viewBasicEditMultis={viewBasicEditMultis}
              {...rest}
            />
          </>
        );
      default:
        return '';
    }
  };

  return (
    <>
      {!openAdvancedModal && (
        <Stack key={`${templateOps.getElementType(elementItem)}`} width="100%" display="flex">
          {renderItem(elementItem, previewMode, setOpenAdvancedModal)}
        </Stack>
      )}
      <Modal open={openAdvancedModal} onClose={() => setOpenAdvancedModal(false)}>
        <Box
          key={`modal-box-${templateOps.getElementType(elementItem)}`}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            maxHeight: '50%',
            maxWidth: '50%',
            top: '25%',
            left: '25%',
            paddingTop: '1%',
            paddingRight: '1%',
            paddingLeft: '1%',
            paddingBottom: '1%',
            overflow: 'auto'
          }}
        >
          {renderItem(elementItem, previewMode)}
        </Box>
      </Modal>
    </>
  );
};

TemplateItem.defaultProps = {
  isSettingsMode: false,
  envSettings: 'gmv',
  fieldsTableConenction: [],
  handleFieldMenu: () => {},
  fieldsMenusValues: []
};
TemplateItem.propTypes = {
  annotationTemplate: PropTypes.object.isRequired,
  rowNumber: PropTypes.number.isRequired,
  columnNumber: PropTypes.number.isRequired,
  itemNumber: PropTypes.number.isRequired,
  previewMode: PropTypes.string.isRequired,
  isSettingsMode: PropTypes.bool,
  envSettings: PropTypes.string,
  fieldsTableConenction: PropTypes.array,
  handleFieldMenu: PropTypes.func,
  fieldsMenusValues: PropTypes.array
};

const TemplateCol = ({ annotationTemplate, rowNumber, columnNumber, ...rest }) => {
  const totalItemsInColumn = templateOps.getItemsInColumn({
    annotationTemplateObject: annotationTemplate,
    rowNumber,
    columnNumber
  });
  const itemsToRender = [];
  for (let itemNumber = 1; itemNumber <= totalItemsInColumn; itemNumber += 1) {
    itemsToRender.push(
      <TemplateItem
        key={`${templateOps.getName(annotationTemplate)}-element-${itemNumber}`}
        rowNumber={rowNumber}
        annotationTemplate={annotationTemplate}
        columnNumber={columnNumber}
        itemNumber={itemNumber}
        {...rest}
      />
    );
  }
  return itemsToRender;
};

TemplateCol.propTypes = {
  annotationTemplate: PropTypes.object.isRequired,
  rowNumber: PropTypes.number.isRequired,
  columnNumber: PropTypes.number.isRequired
};

const TemplateRow = ({ annotationTemplate, rowNumber, ...rest }) => {
  const totalColumns = templateOps.getColumnsForRow({
    annotationTemplateObject: annotationTemplate,
    rowNumber
  });
  const columnsToRender = [];
  for (let columnNumber = 1; columnNumber <= totalColumns; columnNumber += 1) {
    columnsToRender.push(
      <Stack
        direction="column"
        width="100%"
        marginTop="1%"
        key={`${templateOps.getName(annotationTemplate)}-column-${columnNumber}`}
      >
        <TemplateCol
          rowNumber={rowNumber}
          annotationTemplate={annotationTemplate}
          columnNumber={columnNumber}
          {...rest}
        />
      </Stack>
    );
  }
  return (
    <>
      <Stack
        key={`${templateOps.getName(annotationTemplate)}-row`}
        direction="row"
        width="100%"
        display="flex"
      >
        {columnsToRender}
      </Stack>
      <ColBreak />
    </>
  );
};

TemplateRow.propTypes = {
  annotationTemplate: PropTypes.object.isRequired,
  rowNumber: PropTypes.number.isRequired
};

const AnnotationTemplatePreview = ({ annotationTemplate, ...rest }) => {
  const totalRows = templateOps.getRows(annotationTemplate);
  const rowsToRender = [];

  for (let rowNumber = 1; rowNumber <= totalRows; rowNumber += 1) {
    rowsToRender.push(
      <TemplateRow
        key={`${templateOps.getName(annotationTemplate)}-row-${rowNumber}`}
        rowNumber={rowNumber}
        annotationTemplate={annotationTemplate}
        {...rest}
      />
    );
  }
  return (
    <form id="videoEditorForm" onSubmit={event => event.preventDefault()}>
      {rowsToRender}
    </form>
  );
};

AnnotationTemplatePreview.propTypes = {
  annotationTemplate: PropTypes.object.isRequired,
  previewMode: PropTypes.string.isRequired
};

export default AnnotationTemplatePreview;
